import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import * as Types from './purchasePlus_graphql'

export const CreateTemporaryQuoteModalLineFragmentDoc = gql`
  fragment CreateTemporaryQuoteModalLine on RequisitionLine {
    id
    uuid
    quantity
  }
` as unknown as DocumentNode<Types.CreateTemporaryQuoteModalLineFragment, unknown>
